module.exports = __webpack_public_path__ + "static/fonts/PorscheNextPashtoTT-Bold.39b5847b.ttf";